import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { reloadOnce } from "./utils/chunkReload";

// adjust the paths if your locales folder is elsewhere
import en from "./locales/en.json";

// Default to EN; switch to FR if URL starts with /fr
const urlLang =
  typeof window !== "undefined" && window.location.pathname.startsWith("/fr")
    ? "fr"
    : "en";

// English ships in the main bundle (it is also the fallback). French is its own
// chunk, fetched only on /fr pages or when the language switcher asks for it, so
// English visitors don't download it. changeLanguage("fr") waits for it to load.
// If the chunk is gone (a deploy since the page loaded), reload like a missing
// page chunk does rather than leave English labels on the French page.
const lazyLocales = {
  type: "backend",
  read(language, namespace, callback) {
    if (language !== "fr") return callback(null, {});
    import("./locales/fr.json").then(
      (m) => callback(null, m.default),
      (err) => { if (!reloadOnce(err)) callback(err, null); },
    );
  },
};

/** Resolves once the page's language is loaded: index.js waits for it before hydrating. */
export const i18nReady = i18n
  .use(lazyLocales)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    partialBundledLanguages: true,
    lng: urlLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    // If French is ever slow to arrive, show English until it does instead of
    // suspending (there is no Suspense boundary around the Navbar/Footer).
    react: { useSuspense: false },
  });

export default i18n;
